import React, { useState, useContext, useRef, useEffect } from "react";
import LessonContext from "context/lessonContext/LessonContext";
import UserContext from "context/userContext/UserContext";
import VideoPlayerSkeleton from "../skeleton/videoPlayerSkeleton";

const VideoPlayerBunnyNetCourse = ({ videoUrl, thumbnailUrl, content }) => {
  const { updateLessonCompletionData } = useContext(LessonContext);
  const { userData } = useContext(UserContext);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isInstitutionUser, setIsInstitutionUser] = useState(false);
  const playerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  
  console.log(videoUrl + ' - ' +thumbnailUrl)

  useEffect(() => {
    if (content) {
      updateLessonCompletionData(content);
    }
  }, [content]);

  useEffect(() => {
    if (Array.isArray(userData) && userData[0] && userData[0].is_institution_user === 1) {
      setIsInstitutionUser(true);
    } else {
      setIsInstitutionUser(false);
    }
  }, [userData]);

  useEffect(() => {
    // Set loading to false after a short delay or when resources are loaded
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Adjust timing as needed
    
    return () => clearTimeout(timer);
  }, []);
  
  // Return skeleton while loading
  if (isLoading) {
    return <VideoPlayerSkeleton />;
  }

  return (
    <div className="bunney-net-player" style={{ position: "relative", width: "100%", height: "100%" }}>
  
      {isPlaying && (
        <iframe
          src={`https://iframe.mediadelivery.net/embed/370995/${videoUrl}?autoplay=false&loop=false&muted=${isInstitutionUser ? "true" : "false"}&preload=true&responsive=true`}
          loading="lazy"
          className="responsive-iframe"
          style={{ 
            width: "100%", 
            height: "60vh", 
            maxWidth: "100%", 
            border: "none",
            borderRadius: "15px"
          }}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default VideoPlayerBunnyNetCourse;